<template>
  <div class="card-billing  block-card card-border big-card-block">
    <v-expansion-panel 
      :value="panel" 
      expand>
      <v-expansion-panel-content :lazy="lazyRendering">
        <template v-slot:header>
          <div class="block-card-title handle">
            <div class="title-icon">
              <span class="botter-Billing-icon white--text text-lg-2" />
            </div>

            <h4>
              Invoice
              <v-icon 
                v-if = "errorsCount && errorsCount.errorsCount" 
                color = "error" 
                style = "margin-left: 4px;">error</v-icon>
              <span class="text--error" v-if="!validData">(Invalid Card Data)</span>
            </h4>
          </div>
        </template>
        <form-validation v-model = "errorsCount" v-if="validData">
          <div class="">
            <div class="block-card-body">
              <v-layout 
                row 
                wrap>

                <v-flex xs12>

                  <label>Recipient name</label>
                  <vTextareaAutocomplete
                    v-model="data.recipient_name"
                    :type="'textfield'"
                    :validation-rules="autocompleteBillingValidationRules"
                  />

                  <label>Order number</label>
                  <vTextareaAutocomplete
                    v-model="data.order_number"
                    :type="'textfield'"
                    :validation-rules="autocompleteBillingValidationRules"
                  />

                  <label>Currency</label>
                  <vTextareaAutocomplete
                    v-model="data.currency"
                    :type="'textfield'"
                    :validation-rules="autocompleteBillingValidationRules"
                  />

                  <label>Payment method</label>
                  <vTextareaAutocomplete
                    v-model="data.payment_method"
                    :type="'textfield'"
                    :validation-rules="autocompleteBillingValidationRules"
                  />

                                <label>Timestamp</label>
                                <vTextareaAutocomplete
                                  v-model="data.timestamp"
                                  :type="'textfield'"
                                  :validationRules="autocompleteBillingValidationRules"
                                ></vTextareaAutocomplete>

                </v-flex>

                <v-layout 
                  v-if="data.address" 
                  row 
                  wrap 
                  class="mt-4">

                  <v-flex md4>
                    <label for="">Street 1</label>
                    <vTextareaAutocomplete
                      v-model="data.address.street_1"
                      :type="'textfield'"
                      :validation-rules="autocompleteBillingValidationRules"
                    />
                  </v-flex>

                  <v-flex md4>
                    <label for="">Street 2</label>
                    <vTextareaAutocomplete
                      v-model="data.address.street_2"
                      :type="'textfield'"
                      :validation-rules="autocompleteBillingValidationRules"
                    />
                  </v-flex>

                  <v-flex md4>
                    <label for="">Postal code</label>
                    <vTextareaAutocomplete
                      v-model="data.address.postal_code"
                      :type="'textfield'"
                      :validation-rules="autocompleteBillingValidationRules"
                    />
                  </v-flex>

                  <v-flex md4>
                    <label for="">City</label>
                    <vTextareaAutocomplete
                      v-model="data.address.city"
                      :type="'textfield'"
                      :validation-rules="autocompleteBillingValidationRules"
                    />
                  </v-flex>

                  <v-flex md4>
                    <label for="">State</label>
                    <vTextareaAutocomplete
                      v-model="data.address.state"
                      :type="'textfield'"
                    />
                  </v-flex>

                  <v-flex md4>
                    <label for="">Country</label>
                    <vTextareaAutocomplete
                      v-model="data.address.country"
                      :type="'textfield'"
                      :validation-rules="autocompleteBillingValidationRules"
                    />
                  </v-flex>

                </v-layout>
              </v-layout>
            </div>



            <div class="d-block">
              <div 
                v-for="(adj,index) in data.adjustments" 
                class="card-inner-wrapper d-block">
                <v-layout 
                  row 
                  wrap>

                  <v-flex md6>
                    <label for="">Name</label>
                    <vTextareaAutocomplete
                      v-model="adj.name"
                      :type="'textfield'"
                      :validation-rules="autocompleteBillingValidationRules"
                    />
                  </v-flex>

                  <v-flex md6>
                    <label for="">Amount</label>
                    <vTextareaAutocomplete
                      v-model="adj.amount"
                      :type="'textfield'"
                      :validation-rules="autocompleteBillingValidationRules"
                    />
                  </v-flex>

                </v-layout>
                <v-btn
                  fab
                  small 
                  color="" 
                  class="delete-button"
                  @click="deleteAdjustment(index)"
                ><v-icon 
                  small 
                  color="#666">delete_outline</v-icon></v-btn>
              </div>
              <!--                            <v-btn-->
              <!--                              large round flat block-->
              <!--                              class="primary&#45;&#45;text"-->
              <!--                              @click="addAdjustment"-->
              <!--                            >-->
              <!--                                <v-icon>add_circle_outline</v-icon>-->
              <!--                                Add Adjustment-->
              <!--                            </v-btn>-->
            </div>


            <div class="block-card-body pb-0">
              <h3>Invoice items</h3>
            </div>

            <draggable 
              v-model="data.elements" 
              group="cards-billing-elements" 
              handle=".handle-billing-elements" 
              @start="drag=true" 
              @end="drag=false">
              <div 
                v-for="(ele,index) in data.elements" 
                class="card-inner-wrapper  d-block">
                <v-layout 
                  row 
                  wrap>

                  <v-flex md4>
                    <label for="">Title</label>
                    <vTextareaAutocomplete
                      v-model="ele.title"
                      :type="'textfield'"
                      :validation-rules="autocompleteBillingValidationRules"
                    />
                  </v-flex>

                  <v-flex md4>
                    <label for="">Subtitle</label>
                    <vTextareaAutocomplete
                      v-model="ele.subtitle"
                      :type="'textfield'"
                      :validation-rules="autocompleteBillingValidationRules"
                    />
                  </v-flex>

                  <v-flex md4>
                    <label for="">Quantity</label>
                    <vTextareaAutocomplete
                      v-model="ele.quantity"
                      :type="'textfield'"
                      :validation-rules="autocompleteBillingValidationRules"
                    />
                  </v-flex>

                  <v-flex md4>
                    <label for="">Price</label>
                    <vTextareaAutocomplete
                      v-model="ele.price"
                      :type="'textfield'"
                      :validation-rules="autocompleteBillingValidationRules"
                    />
                  </v-flex>

                  <v-flex md4>
                    <label for="">Currency</label>
                    <vTextareaAutocomplete
                      v-model="ele.currency"
                      :type="'textfield'"
                      :validation-rules="autocompleteBillingValidationRules"
                    />
                  </v-flex>

                  <v-flex md4>
                    <label for="">Image url</label>
                    <vTextareaAutocomplete
                      v-model="ele.image_url"
                      :type="'textfield'"
                      :validation-rules="autocompleteBillingValidationRules"
                    />
                  </v-flex>

                </v-layout>
                <div class="inner-block-actions">
                  <v-btn
                    fab
                    small 
                    color="" 
                    class=""
                    @click="deleteElement(index)"
                  ><v-icon color="red">delete_outline</v-icon></v-btn>
                  <v-btn 
                    class="handle-billing-elements" 
                    fab 
                    small 
                    color=""><v-icon color="#666">height</v-icon></v-btn>
                </div>
              </div>
            </draggable>
            <v-btn
              large 
              round 
              flat 
              block
              class="primary--text"
              @click="addElement"
            >
              <v-icon>add_circle_outline</v-icon>
              Add Element
            </v-btn>

            <div class="block-card-body">
              <v-layout>
                <v-flex xs12>
                  <label for="">Subtotal</label>
                  <vTextareaAutocomplete
                    v-model="data.summary.subtotal"
                    :type="'textfield'"
                    :validation-rules="autocompleteBillingValidationRules"
                  />
                  <label for="">Shipping cost</label>
                  <vTextareaAutocomplete
                    v-model="data.summary.shipping_cost"
                    :type="'textfield'"
                    :validation-rules="autocompleteBillingValidationRules"
                  />

                  <label for="">Total tax</label>
                  <vTextareaAutocomplete
                    v-model="data.summary.total_tax"
                    :type="'textfield'"
                    :validation-rules="autocompleteBillingValidationRules"
                  />
                  <label for="">Total cost</label>
                  <vTextareaAutocomplete
                    v-model="data.summary.total_cost"
                    :type="'textfield'"
                    :validation-rules="autocompleteBillingValidationRules"
                  />
                </v-flex>
              </v-layout>
            </div>





          </div>
        </form-validation>
        <slot name = "tail" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import common from '../../../../utils/common'
import draggable from 'vuedraggable'
import FormValidation from '../FormValidation'
export default {
  name: 'CardBilling',
  components: {
    draggable,
    FormValidation
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    index: {
      type: Number,
      default: () => {
        return 0
      }
    },
    blocksList: {
      type: Array,
      default: () => {
        return []
      }
    },
    slug: {
      type: String,
      required: true
    },
    validData: {
      type: Boolean,
      default: ()=> {
        return false
      }
    }
  },
  data() {
    return {
      valid: true,
      panel: 1,
      common,
      errorsCount: { errorsCount: 0 },
      lazyRendering: true,
      autocompleteBillingValidationRules: [v => !!v || 'Value is Required']
    }
  },
  computed: {},
  watch: {
    errorsCount(val) {
      this.$emit('input', { errorsCount: val.errorsCount })
      this.data.errorsCount = val.errorsCount
    }
  },
  mounted() {
    if (this.data.errorsCount !== undefined) {
      this.errorsCount = this.data.errorsCount
    } else {
      // disabling Lazy rendering so we can grip errors count
      this.lazyRendering = false
      setTimeout(() => {
        // then we turn it on again to keep the performance up
        this.lazyRendering = true
      }, 1000)
    }
    if (!this.data.adjustments) {
      this.data.adjustments = []
    }
  },
  methods: {
    addAdjustment() {
      this.data.adjustments.push({
        name: 'New Customer Discount',
        amount: 20
      })
    },
    deleteElement(index) {
      this.data.elements.splice(index, 1)
    },
    addElement() {
      this.data.elements.push({
        title: 'Classic White T-Shirt',
        subtitle: '100% Soft and Luxurious Cotton',
        quantity: 2,
        price: 50,
        currency: 'USD',
        image_url: 'http://petersapparel.parseapp.com/img/whiteshirt.png'
      })
    },
    deleteAdjustment(index) {
      this.data.adjustments.splice(index, 1)
    }
  }
}
</script>

<style scoped>
</style>
